import { createSlice } from '@reduxjs/toolkit';

import { getGlobalParam } from '@agilemd/ui-utils';

import reexportSelector from '../utils/reexportSelector.js';
import { reset } from './actions.js';

// patient age is inferred from ehr context so resetting we will default back to that value
const originalPatientAge = getGlobalParam('patientAge', null);
const {
  isEmergency,
  isInpatient,
  needsICUBed,
  patientAge,
  patientHealthStatus,
  patientPhysicalStatus,
  tier,
  practitionerSpecialty
} = getGlobalParam('questionValues');

const initialState = {
  isEmergency,
  isInpatient,
  needsICUBed,
  patientAge,
  patientHealthStatus,
  patientPhysicalStatus,
  tier,
  practitionerSpecialty
};
const reexport = reexportSelector('answers');

export const answerSlice = /** @type {import('@reduxjs/toolkit').Slice} */ (
  createSlice({
    name: 'answers',
    initialState,
    reducers: {
      setAnswer: (state, { payload: { type, value } }) => {
        state[type] = value;
      }
    },
    extraReducers: {
      [reset]: () => ({
        isEmergency: null,
        isInpatient: null,
        needsICUBed: null,
        patientAge: originalPatientAge,
        patientHealthStatus: null,
        patientPhysicalStatus: null,
        tier: null,
        practitionerSpecialty
      })
    }
  })
);

export const { setAnswer } = answerSlice.actions;

export const getAnswer = reexport((state, answerType) => state[answerType]);
export const getAllAnswers = reexport(state => ({
  isEmergency: state.isEmergency,
  isInpatient: state.isInpatient,
  needsICUBed: state.needsICUBed,
  patientAge: state.patientAge,
  patientHealthStatus: state.patientHealthStatus,
  patientPhysicalStatus: state.patientPhysicalStatus,
  tier: state.tier,
  practitionerSpecialty: state.practitionerSpecialty
}));

export default answerSlice.reducer;
